import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes", "columnsWidth", "children", "theme", "pageNavigatorProps", "columns", "rows", "withHeader"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { PageNavigator } from "../PageNavigator";
import Scrollbar from "../Scrollbar";
import { TableWithProps } from "./components/TableWithProps";
import { defaultPropArray, defaultPropObject } from "../constants";
import { isArray, isObject } from "../utils/type";
import styles from './Table.css';
var cx = classNames.bind(styles);
export var Table = /*#__PURE__*/forwardRef(function Table(_ref, ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      _ref$columnsWidth = _ref.columnsWidth,
      columnsWidth = _ref$columnsWidth === void 0 ? defaultPropArray : _ref$columnsWidth,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      pageNavigatorProps = _ref.pageNavigatorProps,
      columns = _ref.columns,
      rows = _ref.rows,
      _ref$withHeader = _ref.withHeader,
      withHeader = _ref$withHeader === void 0 ? true : _ref$withHeader,
      props = _objectWithoutProperties(_ref, _excluded);

  var content = isArray(columns) && isArray(rows) ? /*#__PURE__*/React.createElement(TableWithProps, {
    columns: columns,
    rows: rows,
    withHeader: withHeader
  }) : children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Scrollbar, null, /*#__PURE__*/React.createElement("table", _extends({}, props, {
    ref: ref,
    className: cx('root_component', classes.root, _defineProperty({}, "theme_".concat(theme), theme))
  }), columnsWidth.length > 0 && /*#__PURE__*/React.createElement("colgroup", null, columnsWidth === null || columnsWidth === void 0 ? void 0 : columnsWidth.map(function (width, idx) {
    return /*#__PURE__*/React.createElement("col", {
      key: "".concat(width + idx),
      width: width
    });
  })), content)), isObject(pageNavigatorProps) && /*#__PURE__*/React.createElement(PageNavigator, pageNavigatorProps));
});
export default Table;